import { Provider } from "@gadgetinc/react";
import { AppProvider } from "@shopify/polaris";
import { PostHogProvider } from "posthog-js/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { api } from "./api";
import App from "./App";
import "./index.css";
import "./instrument";

const REACT_APP_PUBLIC_POSTHOG_KEY =
  "phc_XVmaqF4BaKhxxW4IHvCFPXHRGnBhPNrLvQGDFCxh1mV";
const REACT_APP_PUBLIC_POSTHOG_HOST = "https://eu.i.posthog.com";

const options = {
  api_host: REACT_APP_PUBLIC_POSTHOG_HOST,
};

const root = document.getElementById("root");
if (!root) throw new Error("#root element not found for booting react app");

console.log(REACT_APP_PUBLIC_POSTHOG_KEY);

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <PostHogProvider apiKey={REACT_APP_PUBLIC_POSTHOG_KEY} options={options}>
      <AppProvider>
        <Provider
          api={api}
          auth={{
            signOutActionApiIdentifier: "signOut",
            signInPath: "/dashboard",
          }}
        >
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </AppProvider>
    </PostHogProvider>
  </React.StrictMode>,
);
